// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "headerShortId -NAn_";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "nodeFormWrapper-yP9S";
var _a = "nodePopup-SWEU";
var _b = "sidebarHeaderWrapper-kOoB";
var _c = ".8rem";
var _d = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "headerShortId", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "nodeFormWrapper", _a as "nodePopup", _b as "sidebarHeaderWrapper", _c as "smallFontSize", _d as "unusedNodeColor" }
